module.exports = __webpack_public_path__ + "img/consumer_code.58262df1.png";